module.exports = __webpack_public_path__ + "img/Jakarta_mobility_study_frontcover.11b909ec.jpg";